import { apiClient } from "../config";

async function exportForm(id: any) {
  const res = await apiClient.get(`/admin/dynamic-forms/${id}/form-data`);
  return res.data;
}

export default exportForm;
